import {
  Box, 
  Grid, 
  Button,
  TextField
} from "@mui/material";
import styled from "styled-components";

interface PageCardProps {
  padding:number;
  backgroundRequired: boolean
}

export const PageCard = styled(Box)<PageCardProps>(({ theme, padding, backgroundRequired=true }) => ({
  padding: theme.spacing(padding),
  backgroundColor: (backgroundRequired)? theme.palette.white.main : 'transparent',
  borderRadius: theme.palette.custom.borderRadius,
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(4),
}));

export const TabTitle = styled(Box)(({ theme }) => ({
  color: theme.palette.white.main,
  fontWeight: 'bold',
  fontSize: '16px',
  backgroundColor: theme.palette.primary.main,
  padding: theme.spacing(1),
  textTransform: 'capitalize',
  
}))

export const BasicDetailItemContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '100%',
  padding: theme.spacing(2),
  minHeight: theme.spacing(9)
}));

export const UserDetailItemContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '100%',
  padding: theme.spacing(2),
}));

export const UserWorkerPreferenceItemContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  width: '100%',
  padding: theme.spacing(1.5),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  height: '100%',
}));

export const BasicDetailItemBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const CustomCard = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(4),
}));

export const AddButton = styled(Button)(({theme}) => ({
  marginTop: `${theme.spacing(-1)} !important`,
  padding: `${0} !important`
}));

export const CustomTextField = styled(TextField)(({theme}) => ({
  
}));

export const DocsContainer = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(2),
  width: '100%',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.palette.custom.borderRadius,
}));

export const DateContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: theme.spacing(3),
}));

export const DateTextField = styled(TextField)(({ theme }) => ({
  width: theme.spacing(25), // Increased width for better readability
  margin: theme.spacing(0, 1),
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadius,
    '& input': {
      textAlign: 'center',
      padding: '10px 8px', // Adjust padding to match the design
      fontSize: '0.9rem',
    },
    '& fieldset': {
      borderColor: '#e0e0e0', // Light grey border
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
}));

export const ButtonGroupContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2), 
  justifyContent: 'flex-end',
}));

const ActionButton = styled(Button)(({theme}) => ({
  padding: theme.spacing(1, 3),
  borderRadius: `${theme.spacing(1)} !important`,
  textTransform: 'capitalize',
  minWidth: '200px !important',
}))

export const CancelButton = styled(ActionButton)(({theme}) => ({
  borderColor: `${theme.palette.success.main} !important`,
  color: `${theme.palette.success.main} !important`,

  '&.Mui-disabled': {
    borderColor: `${theme.palette.grey[300]} !important`,
    color: `${theme.palette.grey[300]} !important`,
    opacity: 0.5
  }
}));

export const SaveButton = styled(ActionButton)(({theme}) => ({
  borderColor: theme.palette.success.main,
  color: theme.palette.white.main,

  '&.Mui-disabled': {
    borderColor: `${theme.palette.grey[300]} !important`,
    color: `${theme.palette.grey[300]} !important`,
    opacity: 0.5
  }
  
  // '&:hover': {
  //   backgroundColor: theme.palette.success.main,
  //   color: theme.palette.white.main,
  // }
}))

export const VerificationImageContainer = styled(Grid)(({theme}) => ({
  marginTop: theme.spacing(0.5),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& img': {
      // You'll need to define a max size for the icon so it doesn't break the layout
      width: '40px', 
      height: '40px',
  },
}))

export const DocumentExpiring = styled(Box)(({theme}) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.white.main,
  padding: theme.spacing(0.5, 1),
  fontSize: '0.75rem',
  fontWeight: 'bold',
  display: 'inline-block',
  width: "100%",
}));